import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import vensoRepository from "@/services/VensoRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export function saveDeliveryNoticeComment(groupId, accessToken, orderId, comment) {
    new SaveDeliveryNoticeComment(groupId, accessToken, orderId, comment)
        .enqueue();
}
export default class SaveDeliveryNoticeComment extends AbstractCommand {
    groupId;
    accessToken;
    orderId;
    comment;
    constructor(groupId, accessToken, orderId, comment) {
        super();
        this.groupId = groupId;
        this.accessToken = accessToken;
        this.orderId = orderId;
        this.comment = comment;
    }
    async execute() {
        try {
            await vensoRepository.saveDeliveryNoticeComment(this.groupId, this.accessToken, this.orderId, this.comment);
        }
        catch (e) {
            alerts.error(trans(`${this.name()}.error`));
            throw e;
        }
    }
    name() {
        return 'save_delivery_notice_comment';
    }
}
